"use strict";
// @ts-ignore
try {
    self['workbox:core:6.1.2'] && _();
}
catch (e) { }
